import { render, staticRenderFns } from "./PlanBabyByEffect.vue?vue&type=template&id=28af8dec&scoped=true&"
import script from "./PlanBabyByEffect.vue?vue&type=script&lang=js&"
export * from "./PlanBabyByEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28af8dec",
  null
  
)

export default component.exports